import { fetch } from '../services/fetch'
import { routes } from '../config'

export const getVisitTypes = payload => fetch.post(routes.getVisitTypes, payload)

export const getInstitutionsInRange = (data, payload) => fetch.post(routes.getInstitutionsInRange, data, payload)

export const getVisitTimes = (data, payload) => fetch.post(routes.getAvailableVisitTimes, data, payload)

export const bookAppointment = (data, payload) => fetch.post(routes.bookAppointment, data, payload)
